import { render, staticRenderFns } from "./ViewLedger.vue?vue&type=template&id=ba9b7f80&scoped=true"
import script from "./ViewLedger.vue?vue&type=script&lang=js"
export * from "./ViewLedger.vue?vue&type=script&lang=js"
import style0 from "./ViewLedger.vue?vue&type=style&index=0&id=ba9b7f80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9b7f80",
  null
  
)

export default component.exports